import React, { useEffect } from 'react';

import { Page } from '../../routes';
import { useGetCurrentPage } from '../../currentPage';

const PageTracker: React.FC<React.PropsWithChildren<unknown>> = () => {
  const ATInternetData = window.ATInternetData;
  const currentPage = useGetCurrentPage();

  useEffect(() => {
    if (
      !currentPage ||
      currentPage === Page.NOT_IMPLEMENTED_YET ||
      !ATInternetData?.tag
    ) {
      return;
    }

    const { tag, customObject } = ATInternetData;

    tag.page.send({
      name: currentPage,
      event: null,
      callback: null,
      customObject,
    });
  }, [ATInternetData, currentPage]);

  return null;
};

export { PageTracker };
